import { pick, round } from 'lodash';

export const convertFloatToPercentage = (num: number) => {
  const percentage = num * 100;

  if (num === 0) {
    return '0%';
  }

  if (percentage < 1) {
    return '<1%';
  }

  if (percentage > 100) {
    return '100%';
  }

  return `${round(percentage)}%`;
};

type GetPropertiesDiffProps<T extends object> = {
  before?: T;
  after: T;
};

export const getPropertiesDiff = <T extends object>({
  before,
  after,
}: GetPropertiesDiffProps<T>): Partial<T> => {
  if (!before) return after;
  const allKeys = [...new Set([...Object.keys(before), ...Object.keys(after)])];
  const diffKeys = allKeys.filter(
    (key) => before[key as keyof T] !== after[key as keyof T]
  );

  return pick(after, diffKeys);
};

export const getInitials = (fullName?: string) =>
  fullName
    ?.split(' ')
    ?.map((word) => word[0]?.toUpperCase())
    ?.join('') ?? '';
